import commonJs from './common/app';
import initParallax from './animations/cpParallax';
import initThematicBlockAlpine from './alpine/cpThematicBlockAlpine';

document.addEventListener('DOMContentLoaded', () => {
  commonJs();
  initParallax();
  initThematicBlockAlpine();
});
